import { twJoin } from "tailwind-merge";

import { PinForm } from "../auth/pin-form";
import { DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import type { Step1Data, Step3Data } from "./common";
import { EmployeeFormStep1 } from "./employee-form-step-1";
import { EmployeeFormStep3 } from "./employee-form-step-3";

interface EmployeeFormProps {
  step1Data?: Step1Data;
  step2Data?: { pin: string };
  step3Data?: Step3Data;
  onStep1Submit: (data: Step1Data) => void;
  onStep2Submit: (data: { pin: string }) => void;
  onStep3Save: (data: Step3Data) => void;
  onStep3Submit: (data: Step3Data) => void;
  currentStep: number;
  setCurrentStep: (step: number) => void;
  onOpenCreateRoleModal: (name: string) => void;
}

export function EmployeeForm({
  onStep1Submit,
  onStep2Submit,
  onStep3Submit,
  step2Data,
  step1Data,
  currentStep,
  setCurrentStep,
  onOpenCreateRoleModal,
  onStep3Save,
  step3Data,
}: EmployeeFormProps) {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-3 gap-2">
        {[0, 1, 2].map((step) => {
          return (
            <button
              className={twJoin(
                "h-1.5 rounded-full",
                step <= currentStep ? "bg-primary" : "bg-muted"
              )}
              key={step}
              onClick={
                step < currentStep
                  ? () => {
                      setCurrentStep(step);
                    }
                  : undefined
              }
              type="button"
            />
          );
        })}
      </div>
      <DialogHeader className="space-y-0">
        <DialogTitle className="subtitle font-heading text-foreground text-center leading-loose">
          {
            [
              "Create employee",
              "Create 4 digit PIN",
              "Define employee permissions",
            ][currentStep]
          }
        </DialogTitle>
        <DialogDescription className="body text-foreground text-center">
          {
            [
              "Enter employee details to create a Plasma POS log in",
              "Choose a PIN for this employee to log into Plasma POS",
              "Specify the locations, assign roles, and set permissions for the employee in the POS system.",
            ][currentStep]
          }
        </DialogDescription>
      </DialogHeader>
      {currentStep === 0 && (
        <EmployeeFormStep1 data={step1Data} onSubmit={onStep1Submit} />
      )}
      {currentStep === 1 && (
        <PinForm
          checkIfPinInUse
          className="gap-5"
          onSubmit={(pin) => onStep2Submit({ pin })}
          submitButtonText="Next"
          value={step2Data?.pin}
        />
      )}
      {currentStep === 2 && (
        <EmployeeFormStep3
          data={step3Data}
          onOpenCreateRoleModal={onOpenCreateRoleModal}
          onSaveData={onStep3Save}
          onSubmit={onStep3Submit}
        />
      )}
    </div>
  );
}
